export default __webpack_public_path__ + "static/media/18.5e918773.jpg";